// AIDEV-NOTE: Rails-compatible param serializer. Handles arrays as key[]=val
// and nested objects as key[nestedKey]=val. Needed because Axios 0.28 doesn't
// serialize these for Rails. Used by SPA data hooks that call PaginationController.
const serializeParams = (obj: Record<string, unknown>, prefix = ''): string => {
  const parts: string[] = [];

  Object.entries(obj).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}[${key}]` : key;

    if (Array.isArray(value)) {
      value.forEach(v => parts.push(`${encodeURIComponent(`${fullKey}[]`)}=${encodeURIComponent(String(v))}`));
    } else if (value !== null && typeof value === 'object') {
      parts.push(serializeParams(value as Record<string, unknown>, fullKey));
    } else if (value !== undefined && value !== null) {
      parts.push(`${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`);
    }
  });

  return parts.filter(Boolean).join('&');
};

export default serializeParams;
